<script>
    import { onMount } from 'svelte';
    import { allowedCookies, lang } from "./store.js";
    import Cookies from 'js-cookie';
    // -
	function hideCookies(e){
        allowedCookies.set(true);
        Cookies.set('allow-cookies', true, { expires: 365 });
    }
    
    // -
    allowedCookies.set( Cookies.get('allow-cookies') );

</script>




<template lang="pug">
	.cookiesFooter( class:allowed="{$allowedCookies}" )
        +if( '$lang === "esp"' )
            p Nos obligan a molestarte con la obviedad de que este sitio usa cookies
            button( on:click="{hideCookies}" ) Aceptar

            +elseif( '$lang === "cat"' )
                p Ens obliguen a molestar-te amb la obvietat de que aquest lloc web utilitza cookies
                button( on:click="{hideCookies}" ) Acceptar

                +else()
                    p We are forced to annoy you with the obvious fact that this site uses cookies
                    button( on:click="{hideCookies}" ) Accept

</template>




<style global lang="stylus">
	@require "./stylus/globals"
	// -
    .cookiesFooter
        position fixed
        left 0
        width 100%
        bottom 0
        color $n
        background-color $orange
        z-index 998888

        display flex
        flex-flow row
        align-items center
        justify-content center
        padding 10px
        box-shadow 0px -10px 30px rgba(0,0,0,0.3), 0px -2px 4px rgba(0,0,0,0.5)

        will-change transform
        transition transform .3s cubic-bezier(0.49, 0.13, 0.21, 0.97)

        &.allowed
            transform translateY(103%)

        p
            margin-right 30px
            font-size 18px

        button
            margin 0
            padding 5px 10px
            color $orange
            border-radius 6px
            background-color $n
            font-size 16px
            cursor pointer

            border solid $n 2px

            &:hover
                color rgba($b, 0.7)

            &:active
                color $n
                background-color $orange

</style>